import { cleanName, getStores } from "@/apps";

export const AppleIcon = ({ size = 18 }) => (
  <svg viewBox="0 0 384 512" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
  </svg>
);

export const PlayIcon = ({ size = 18 }) => (
  <svg viewBox="0 0 512 512" width={size} height={size} aria-hidden="true">
    <path fill="#00d0ff" d="M47 12C41 15 37 21 37 30v452c0 9 4 15 10 18l236-244z"/>
    <path fill="#00e676" d="M47 12c5-3 12-2 19 2l268 154-51 62z"/>
    <path fill="#ffd600" d="M334 168l64 37c20 12 20 32 0 43l-64 37-51-77z"/>
    <path fill="#ff3d00" d="M47 500c5 3 12 2 19-2l268-154-51-62z"/>
  </svg>
);

// Compact store badges for cards
export const StoreBadges = ({ app, size = "sm" }) => {
  const name = cleanName(app.name);
  const { appStore, playStore } = getStores(app);
  const pad = size === "sm" ? "px-2.5 py-1.5" : "px-3 py-2";
  const stop = (e) => e.stopPropagation();
  const base =
    "hi-cta inline-flex items-center gap-1.5 rounded-lg border border-white/15 bg-black/50 text-white/90 hover:bg-black/80 hover:border-[#3b9bff]/50 " +
    pad;
  return (
    <div className="flex items-center gap-2" data-testid={`store-badges-${app.id}`}>
      <a
        href={appStore}
        target="_blank"
        rel="noopener noreferrer"
        onClick={stop}
        data-testid={`badge-appstore-${app.id}`}
        className={base}
        aria-label={`${name} on the App Store`}
      >
        <AppleIcon size={15} />
        <span className="hi-body text-[11px] font-semibold">App Store</span>
      </a>
      <a
        href={playStore}
        target="_blank"
        rel="noopener noreferrer"
        onClick={stop}
        data-testid={`badge-playstore-${app.id}`}
        className={base}
        aria-label={`${name} on Google Play`}
      >
        <PlayIcon size={15} />
        <span className="hi-body text-[11px] font-semibold">Google Play</span>
      </a>
    </div>
  );
};
